import React, { useEffect, useState } from "react";

const AdminUserMgmt = () =>{
    return(
        <>
        <h1>hsdghdg</h1>
        </>
    )

}
export default AdminUserMgmt